export const loadingActionTypes = {
  SET_LOADING: 'SET_LOADING',
};

export function setLoading(flag) {
  return { type: loadingActionTypes.SET_LOADING, flag };
}

export default function loadingReducer(
  state = {
    loading: false,
  },
  action
) {
  switch (action.type) {
    case loadingActionTypes.SET_LOADING: {
      return { ...state, loading: action.flag };
    }
    default:
      return state;
  }
}
